var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-master-detail-pane",
            { attrs: { "master-width": _vm.isMultiselectModeEnabled ? 6 : 3 } },
            [
              _c(
                "template",
                { slot: "master" },
                [
                  _c(
                    "v-load-nav-list",
                    {
                      attrs: {
                        title: "Invoices",
                        searchPrompt: "Search Invoice Transactions",
                        loading: _vm.loadingTransactions,
                        accurateSince: _vm.accurateSince,
                        loads: _vm.invoices,
                        customerLoads: _vm.invoicesGroupedByCustomer,
                        groupedItems: _vm.selectedGroupedItems,
                        company: _vm.company,
                        "custom-group-icon": _vm.isMultiselectModeEnabled
                          ? "receipt"
                          : "linear_scale"
                      },
                      on: {
                        "update:searchTerm": function($event) {
                          _vm.search = $event
                        },
                        refresh: function($event) {
                          return _vm.loadCompanyTransactions(_vm.company.id)
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "loadTile",
                          fn: function(ref) {
                            var idx = ref.idx
                            var txn = ref.load
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  key: "load_txn_" + idx + "_" + txn.id,
                                  class: {
                                    "primary lighten-1": _vm.isSelectedLoad(txn)
                                  },
                                  attrs: {
                                    inactive: _vm.isSelectedLoad(txn),
                                    ripple: "",
                                    avatar: ""
                                  }
                                },
                                [
                                  _vm.isMultiselectModeEnabled
                                    ? _c(
                                        "v-list-tile-action",
                                        [
                                          _c("v-checkbox", {
                                            attrs: { value: txn },
                                            model: {
                                              value: _vm.multiSelections,
                                              callback: function($$v) {
                                                _vm.multiSelections = $$v
                                              },
                                              expression: "multiSelections"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.selectLoad(txn)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.loadGroupSponsorName(
                                                txn.load.tacticalInfo.loadGroup
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.bookedLoadNickname(txn.load)
                                        ? _c(
                                            "v-list-tile-sub-title",
                                            { staticClass: "text--primary" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.bookedLoadNickname(
                                                      txn.load
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        { staticClass: "text--primary" },
                                        [
                                          txn.load.pickup
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("formatTxDate")(
                                                        txn.load.pickup.when
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            : txn.load.tacticalInfo
                                                .scheduledPickupTime
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("formatTxDate")(
                                                        txn.load.tacticalInfo
                                                          .scheduledPickupTime
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(txn.loadHumanId) +
                                            ": $" +
                                            _vm._s(txn.amount) +
                                            " (" +
                                            _vm._s(txn.status || "[status]") +
                                            ")\n                  "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: _vm.invoiceStatusIcon(txn)
                                              .color,
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.invoiceStatusIcon(txn)
                                                    .icon
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {
                                key: "load_txn_divider_" + idx + "_" + txn.id
                              })
                            ]
                          }
                        },
                        {
                          key: "groupedItemsTile",
                          fn: function(skope) {
                            return [
                              _c(
                                "v-list-group",
                                { key: "invoiceGroupedBy_" + skope.idx },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _vm.isMultiselectModeEnabled
                                        ? [
                                            _c("v-list-tile-action", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    skope.items[0].customer
                                                      .companyName
                                                  ) +
                                                  " (" +
                                                  _vm._s(skope.item) +
                                                  " " +
                                                  _vm._s(skope.items.length) +
                                                  " loads)\n                    "
                                              )
                                            ])
                                          ]
                                        : [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    attrs: {
                                                      color: _vm.invoiceStatusIcon(
                                                        {
                                                          load: {
                                                            loadStatus:
                                                              skope.item
                                                          }
                                                        }
                                                      ).color,
                                                      "text-color": "white",
                                                      small: ""
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.invoiceStatusIcon(
                                                              {
                                                                load: {
                                                                  loadStatus:
                                                                    skope.item
                                                                }
                                                              }
                                                            ).icon
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-title", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(skope.item) +
                                                  "\n                    "
                                              )
                                            ])
                                          ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm._l(skope.items, function(txn) {
                                    return [
                                      _c(
                                        "v-list-tile",
                                        {
                                          key: "grouped_load_" + txn.loadId,
                                          class: {
                                            "primary lighten-1": _vm.isSelectedLoad(
                                              txn
                                            )
                                          },
                                          attrs: {
                                            inactive: _vm.isSelectedLoad(txn),
                                            ripple: "",
                                            avatar: ""
                                          }
                                        },
                                        [
                                          _vm.isMultiselectModeEnabled
                                            ? _c(
                                                "v-list-tile-action",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      value: txn.loadId
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.multiSelections,
                                                      callback: function($$v) {
                                                        _vm.multiSelections = $$v
                                                      },
                                                      expression:
                                                        "multiSelections"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectLoad(txn)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.loadGroupSponsorName(
                                                        txn.load.tacticalInfo
                                                          .loadGroup
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm.bookedLoadNickname(txn.load)
                                                ? _c(
                                                    "v-list-tile-sub-title",
                                                    {
                                                      staticClass:
                                                        "text--primary"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.bookedLoadNickname(
                                                              txn.load
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-sub-title",
                                                {
                                                  staticClass: "text--primary"
                                                },
                                                [
                                                  txn.load.pickup
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatTxDate"
                                                              )(
                                                                txn.load.pickup
                                                                  .when
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : txn.load.tacticalInfo
                                                        .scheduledPickupTime
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatTxDate"
                                                              )(
                                                                txn.load
                                                                  .tacticalInfo
                                                                  .scheduledPickupTime
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(txn.loadHumanId) +
                                                    ": $" +
                                                    _vm._s(txn.amount) +
                                                    "\n                      "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider", {
                                        key: "load_divider_" + txn.loadId
                                      })
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          }
                        },
                        {
                          key: "customerLoadsTile",
                          fn: function(skope) {
                            return [
                              _c(
                                "v-list-group",
                                { key: "customerLoad_" + skope.idx },
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                color: "primary",
                                                "text-color": "white",
                                                small: ""
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(skope.loads.length) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(skope.sponsor) +
                                            "\n                  "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(skope.loads, function(txn) {
                                    return [
                                      _c(
                                        "v-list-tile",
                                        {
                                          key: "grouped_load_" + txn.loadId,
                                          class: {
                                            "primary lighten-1": _vm.isSelectedLoad(
                                              txn
                                            )
                                          },
                                          attrs: {
                                            inactive: _vm.isSelectedLoad(txn),
                                            ripple: "",
                                            avatar: ""
                                          }
                                        },
                                        [
                                          _vm.isMultiselectModeEnabled
                                            ? _c(
                                                "v-list-tile-action",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      value: txn.loadId
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.multiSelections,
                                                      callback: function($$v) {
                                                        _vm.multiSelections = $$v
                                                      },
                                                      expression:
                                                        "multiSelections"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectLoad(txn)
                                                }
                                              }
                                            },
                                            [
                                              _vm.bookedLoadNickname(txn.load)
                                                ? _c(
                                                    "v-list-tile-title",
                                                    {
                                                      staticClass:
                                                        "text--primary"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.bookedLoadNickname(
                                                              txn.load
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                       " +
                                                    _vm._s(
                                                      _vm._.get(
                                                        txn,
                                                        "load.loadStatus",
                                                        ""
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-sub-title",
                                                {
                                                  staticClass: "text--primary"
                                                },
                                                [
                                                  txn.load.pickup
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatTxDate"
                                                              )(
                                                                txn.load.pickup
                                                                  .when
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : txn.load.tacticalInfo
                                                        .scheduledPickupTime
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              txn.load
                                                                .tacticalInfo
                                                                .scheduledPickupTime
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(txn.loadHumanId) +
                                                    ": $" +
                                                    _vm._s(txn.amount) +
                                                    "\n                      "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider", {
                                        key: "load_divider_" + txn.loadId
                                      })
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm.isXeroConnected(_vm.company)
                        ? _c(
                            "template",
                            { slot: "toolbarItems" },
                            [
                              _vm.isXeroConnected(_vm.company) &&
                              _vm.isMultiselectModeEnabled
                                ? _c("v-xero-billing-btn", {
                                    attrs: {
                                      disabled: false,
                                      loading: _vm.loadingBtn,
                                      "invoicing-company": _vm.company,
                                      selections: _vm.multiSelections,
                                      "multi-select-mode":
                                        _vm.isMultiselectModeEnabled
                                    },
                                    on: {
                                      "invoice-created": function($event) {
                                        _vm.multiSelections = []
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isMultiselectModeEnabled
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled:
                                          !_vm.multiSelections ||
                                          _vm.multiSelections.length === 0
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.multiSelections = []
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { "pr-1": "" } }, [
                                        _vm._v("clear")
                                      ]),
                                      _vm._v(
                                        "\n                Clear\n              "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn-toggle",
                                {
                                  staticClass: "mr-3",
                                  model: {
                                    value: _vm.multiselectMode,
                                    callback: function($$v) {
                                      _vm.multiselectMode = $$v
                                    },
                                    expression: "multiselectMode"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.multiSelections = _vm.isMultiselectModeEnabled
                                            ? []
                                            : null
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("checklist")])],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "detail" },
                [
                  _vm.selected
                    ? _c(
                        "v-load-transaction-details",
                        {
                          attrs: {
                            transaction: _vm.selected,
                            invoice: "",
                            company: _vm.company,
                            "banner-title": "" + _vm.selected.loadHumanId,
                            "multi-transaction-export":
                              _vm.isMultiselectModeEnabled,
                            loading: _vm.loadingTransactions
                          },
                          on: {
                            "reset-selected": function($event) {
                              return _vm.selectLoad(null)
                            },
                            reload: function($event) {
                              return _vm.onRefresh()
                            }
                          }
                        },
                        [_c("template", { slot: "toolbarButtons" })],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52642638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52642638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Transactions/Invoices.vue
// module id = null
// module chunks = 